import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DeadlineService {
  private readonly HOURS_SOON = 48 * 60 * 60 * 1000;

  private readonly rules: Array<
    [(deadline: Date | undefined) => boolean, DeadlineStatus]
  > = [
    [(deadline) => deadline == undefined, "none"],
    [
      (deadline) => deadline !== undefined && Date.now() > deadline.getTime(),
      "overdue",
    ],
    [
      (deadline) =>
        deadline !== undefined &&
        Date.now() + this.HOURS_SOON > deadline.getTime(),
      "soon",
    ],
  ];

  deadlineStatus(deadline?: Date): DeadlineStatus {
    return this.rules.find((r) => r[0](deadline))?.[1] ?? "none"; // fallback "none"
  }
}

export type DeadlineStatus = "none" | "soon" | "overdue";
